(function () {
    'use strict';

    a3_cabin_reports.directive('competences', competences);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name certificates
    * @restrict E
    * @description
    *   Implementation of competences
    * @example
    *   Usage:
    *   <competences></competences>
    * @ngInject
    */
    function competences($uibModal, $timeout) {
        function link(scope, element, attrs) {
            scope.manageCompetenceGrading = manageCompetenceGrading;
            scope.selectSubCompetence = selectSubCompetence;
            scope.openGradingModal = openGradingModal;

            scope.trainee.Competences.forEach(function(competence){
                competence.isCollapsed = competence.hasMandatory || competence.hasOptional;
                competence.showComments = competence.hasMandatory || competence.hasOptional || (competence.Comments && competence.Comments != "")
            });

            validateTraineeCompetences(scope.trainee);

            function validateTraineeCompetences(trainee){
                var missingGrading = trainee.Competences.some(c => c.Grading ==  null);
                var missingPerformanceIndicators = trainee.Competences.filter(c => c.hasMandatory).some(c => !c.SubCompetences.some(sub => sub.Selected));
                trainee.isCompetenceValid = !missingGrading && !missingPerformanceIndicators;
            } 

            function manageCompetenceGrading(competence){
                var grading = competence.Grading ? Number(competence.Grading) : null;
                var hadMandatory = competence.hasMandatory;
                var hadOptional = competence.hasOptional;
                competence.hasMandatory = competence.MandatorySub.includes(grading);
                competence.hasOptional = competence.OptionalSub.includes(grading);
                competence.isCollapsed = competence.hasMandatory || competence.hasOptional;
                if(competence.isCollapsed) competence.showComments = true;
                
                //From Mandatory to None remove selected Sub Competences
                if( ((hadMandatory || hadOptional) && (!competence.hasMandatory && !competence.hasOptional))){
                    competence.SubCompetences.forEach(function(sub){
                        sub.Selected = false;
                    });
                }

                validateTraineeCompetences(scope.trainee);

                switch (competence.Grading) {
                    case 5:
                        competence.GradingMessage = competence.GradeA;
                        break;
                    case 4:
                        competence.GradingMessage = competence.GradeB;
                        break;
                    case 3:
                        competence.GradingMessage = competence.GradeC;
                        break;
                    case 2:
                        competence.GradingMessage = competence.GradeD;
                        break;
                    case 1:
                        competence.GradingMessage = competence.GradeE;
                        break;
                    default:
                        competence.GradingMessage = "";
                }

                scope.gradingSelection();
            }
        
            function selectSubCompetence(sub){
                sub.Selected = !sub.Selected;
                if(sub.Selected)    scope.gradingSelection();
                validateTraineeCompetences(scope.trainee);
            }

            function openGradingModal(competence){
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/Training/dlgCompetenceGrading.html',
                    controller: 'CompetenceModalCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        competence: function () { return competence;},
                    }
                });

                modalInstance.result.then(function (grading) {
                    if(grading){
                        manageCompetenceGrading(competence, grading);
                    }
                });
            }
        }
        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/competences.tpl.html',
            scope: {trainee : "=", gradingSelection: "&onGradingSelection"},
            link: link
        }
    }

})();
